import e from "./primitiveColors.js";
const a = {
  primary: {
    DEFAULT: e.blue[700],
    hover: e.blue[800],
    active: e.blue[900]
  },
  secondary: {
    DEFAULT: e.neutral.white,
    hover: e.blue[200],
    active: e.blue[300]
  },
  accent: {
    DEFAULT: e.gold[300],
    hover: e.gold[500],
    surface: e.gold[50]
  },
  surface: {
    DEFAULT: e.neutral.white,
    inverse: e.neutral.black
  },
  background: {
    DEFAULT: e.neutral[50],
    inverse: e.neutral[300]
  },
  neutral: {
    DEFAULT: e.neutral.white,
    inverse: e.neutral[800]
  },
  focus: {
    DEFAULT: e.blue[700],
    inverse: e.neutral.white
  },
  error: {
    DEFAULT: e.red[700],
    hover: e.red[800],
    surface: e.red[50]
  },
  warning: {
    DEFAULT: e.orange[500],
    hover: e.orange[700],
    surface: e.orange[50]
  },
  success: {
    DEFAULT: e.green[600],
    hover: e.green[700],
    surface: e.green[50]
  },
  info: {
    DEFAULT: e.turquoise[600],
    hover: e.turquoise[800],
    surface: e.turquoise[50]
  },
  disabled: {
    DEFAULT: e.neutral[500],
    surface: e.neutral[200]
  },
  current: "currentColor",
  inherit: "inherit",
  transparent: "transparent"
};
export {
  a as default
};
